module.exports = __webpack_public_path__ + "static/img/goods_default_img.c881023.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/goodsList/goods_default_img.jpg
// module id = wBRU
// module chunks = 93